const whoMotivatesYouQuestion = {
  name: 'whomotivatesyou',
  title: 'Who motivates you most?',
  type: 'radiogroup',
  choices: [
    {
      value: 'Partner',
      text: 'Partner',
    },
    {
      value: 'Parent',
      text: 'Parent',
    },
    {
      value: 'Sibling',
      text: 'Sibling',
    },
    {
      value: 'Friend',
      text: 'Friend',
    },
    {
      value: 'Teammate',
      text: 'Teammate',
    },
    {
      value: 'Other',
      text: 'Other',
    },
  ],
  isRequired: true,
  visibleIf: `{invitationcomfort} == "Yes" || {invitationcomfort} == "It depends"`
};

export default whoMotivatesYouQuestion;